import type {AxiosRequestConfig} from 'axios';
import {Partner, Status} from './interface';

export class DeletePartnerBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.partnersRequest.url = `/partners/${id}`;
    return this;
  }
  build() {
    return this.partnersRequest;
  }
}
export class GetAllPartnersRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partners',
    params: {},
  };

  id(id: number) {
    this.partnersRequest.url = `/partners/${id}`;
    return this;
  }
  params(params: object) {
    this.partnersRequest.params = params;
    return this;
  }

  build() {
    return this.partnersRequest;
  }
}
export class GetPartnersCountRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partners/count',
    params: {},
  };
  params(params: object) {
    this.partnersRequest.params = params;
    return this;
  }

  build() {
    return this.partnersRequest;
  }
}

export class CreatePartnersRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/partners',
    data: {},
  };

  data(data: Partner) {
    this.partnersRequest.data = data;
    return this;
  }

  build() {
    return this.partnersRequest;
  }
}

export class UpdatePartnerRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/partners',
    data: {},
  };
  id(id: number) {
    this.partnersRequest.url = `/partners/${id}/admin`;
    return this;
  }
  data(body: Partner | number) {
    this.partnersRequest.data = body;
    return this;
  }
  build() {
    return this.partnersRequest;
  }
}

export class UpdatePartnerStatusRequestBuilder {
  private readonly request: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };
  id(id: number) {
    this.request.url = `/partners/${id}/status`;
    return this;
  }
  data(body: Status) {
    this.request.data = `"${body}"`;
    return this;
  }
  build() {
    return this.request;
  }
}

export class GetAllPartnersInventoryRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partners',
    params: {},
  };

  id(id: number) {
    this.partnersRequest.url = `/partners/${id}/inventory`;
    return this;
  }
  params(params: object) {
    this.partnersRequest.params = params;
    return this;
  }

  build() {
    return this.partnersRequest;
  }
}

export class CreatePartnerWithLogoRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/partners/logo',
    data: {},
    params: {},
  };
  params(params: object) {
    this.partnersRequest.params = params;
    return this;
  }
  data(data: Partner) {
    this.partnersRequest.data = data;
    return this;
  }

  build() {
    return this.partnersRequest;
  }
}

export class UpdatePartnerWithLogoRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/partners/logo',
    data: {},
    params: {},
  };
  params(params: object) {
    this.partnersRequest.params = params;
    return this;
  }
  data(body: any) {
    this.partnersRequest.data = body;
    return this;
  }
  build() {
    return this.partnersRequest;
  }
}

export class RemoveLogoRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/partners',
    data: {},
    params: {},
  };

  id(id: number) {
    this.partnersRequest.url = `/partners/remove-logo/${id}`;
    return this;
  }

  build() {
    return this.partnersRequest;
  }
}

export class GetPartnerLogoRequestBuilder {
  private readonly partnersRequest: AxiosRequestConfig = {
    method: 'GET',
    url: `/partners/logo`,
    params: {},
    headers: {
      responseType: "arraybuffer"
    }
  };

  id(id: number) {
    this.partnersRequest.url = `/partners/logo/${id}`;
    return this;
  }

  build() {
    return this.partnersRequest;
  }
}
